export class ConfigurationConstant {
  static Configuration = 'Configuration'

  static Setting = 'setting'

  static CutoffDateKey = 'CutoffDate'
}
